module.exports = __webpack_public_path__ + "media/videos/video-20e235c0ea33fa4d3ccddc4cd2f387b9.mp4";